module.exports = __webpack_public_path__ + "fonts/Braille6-ANSI.0b076a6a.ttf";